/* Dabi Deri — ürün sayfası kampanya kuralları.
   - Bölüm içeriğini main-product içindeki yer tutucuya taşır.
   - Seçili ürün varyantını ürün formundan izler, toplam ve tasarrufu canlı hesaplar.
   - "Kampanyayla sepete ekle": tetikleyici + ödül tek istekte sepete, kod varsa uygulanır,
     Craft sepet çekmecesi yenilenir. İndirimi Shopify uygular; tema fiyat değiştirmez. */
(() => {
  const fmtMoney = (cents, f) => {
    const n = (Number(cents) || 0) / 100;
    const m = (f || '').match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    const parts = (dec, thou, d) => { let [i, fr] = n.toFixed(d).split('.'); i = i.replace(/\B(?=(\d{3})+(?!\d))/g, thou); return fr !== undefined ? i + dec + fr : i; };
    let out;
    switch (key) {
      case 'amount_no_decimals': out = parts('', ',', 0); break;
      case 'amount_with_comma_separator': out = parts(',', '.', 2); break;
      case 'amount_no_decimals_with_comma_separator': out = parts('', '.', 0); break;
      case 'amount_with_apostrophe_separator': out = parts('.', "'", 2); break;
      default: out = parts('.', ',', 2);
    }
    return f ? f.replace(/\{\{\s*\w+\s*\}\}/, out) : out;
  };

  const productForm = () => document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"][id^="product-form"]');
  const currentVariant = (deal) => {
    const input = productForm()?.querySelector('[name="id"]');
    return input?.value || deal.dataset.curVariant;
  };
  const currentPrice = async (deal, id) => {
    if (id === deal.dataset.curVariant) return Number(deal.dataset.curPrice);
    try {
      const handle = window.location.pathname.split('/products/')[1]?.split(/[/?#]/)[0];
      if (!handle) return Number(deal.dataset.curPrice);
      if (!currentPrice.cache) currentPrice.cache = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`).then((r) => r.json());
      const v = currentPrice.cache.variants.find((x) => String(x.id) === String(id));
      return v ? v.price : Number(deal.dataset.curPrice);
    } catch (e) { return Number(deal.dataset.curPrice); }
  };

  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    // yer tutucuya taşı
    const slot = document.querySelector('[data-dabi-deals-slot]');
    if (slot && root.querySelector('[data-dabi-deal]')) slot.appendChild(root);
    const fmt = root.dataset.moneyFormat;
    const saveTpl = root.closest('.shopify-section')?.querySelector('[data-save-tpl]')?.textContent || '';

    root.querySelectorAll('[data-dabi-deal]').forEach((deal) => {
      const pct = Number(deal.dataset.pct) || 0;
      const tq = Number(deal.dataset.tq) || 1;
      const rq = Number(deal.dataset.rq) || 1;
      const kind = deal.dataset.kind;
      const totalEl = deal.querySelector('[data-deal-total]');
      const wasEl = deal.querySelector('[data-deal-was]');
      const saveEl = deal.querySelector('[data-deal-save]');
      const msg = deal.querySelector('[data-deal-msg]');
      const btn = deal.querySelector('[data-deal-add]');
      const saveText = deal.closest('[data-dabi-deals]').dataset.saveText || '{amount}';

      const reward = () => {
        if (kind === 'same') return null;
        const card = deal.querySelector('[data-deal-reward]:has(input:checked)') || deal.querySelector('[data-deal-reward]');
        if (!card) return null;
        const sel = card.querySelector('[data-reward-variant]');
        if (sel) {
          const o = sel.selectedOptions[0];
          return { id: sel.value, price: Number(o.dataset.price) };
        }
        return { id: card.dataset.variant, price: Number(card.dataset.price) };
      };

      const recalc = async () => {
        const vid = currentVariant(deal);
        const cp = await currentPrice(deal, vid);
        let full; let paid;
        if (kind === 'same') {
          full = cp * (tq + rq);
          paid = cp * tq + Math.round(cp * rq * (100 - pct) / 100);
        } else {
          const r = reward();
          if (!r) { btn.disabled = true; return; }
          full = cp * tq + r.price * rq;
          paid = cp * tq + Math.round(r.price * rq * (100 - pct) / 100);
          // kart fiyatlarını varyanta göre güncelle
          deal.querySelectorAll('[data-deal-reward]').forEach((card) => {
            const sel = card.querySelector('[data-reward-variant]');
            if (!sel) return;
            const p = Number(sel.selectedOptions[0].dataset.price);
            card.dataset.price = p;
            card.querySelector('[data-reward-now]').textContent = fmtMoney(Math.round(p * (100 - pct) / 100), fmt);
            card.querySelector('[data-reward-was]').textContent = fmtMoney(p, fmt);
          });
        }
        btn.disabled = false;
        totalEl.textContent = fmtMoney(paid, fmt);
        wasEl.textContent = full > paid ? fmtMoney(full, fmt) : '';
        if (full > paid) { saveEl.hidden = false; saveEl.textContent = saveText.replace('{amount}', fmtMoney(full - paid, fmt)); } else saveEl.hidden = true;
      };

      deal.addEventListener('change', recalc);
      const form = productForm();
      form?.querySelector('[name="id"]')?.addEventListener('change', recalc);
      document.addEventListener('variant:change', recalc);
      if (window.subscribe && window.PUB_SUB_EVENTS?.variantChange) window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => setTimeout(recalc, 50));
      recalc();

      const say = (t, bad) => { msg.hidden = false; msg.textContent = t; msg.classList.toggle('is-bad', !!bad); };

      btn.addEventListener('click', async () => {
        btn.disabled = true;
        const base = root.dataset.root || '/';
        const vid = currentVariant(deal);
        const items = kind === 'same'
          ? [{ id: Number(vid), quantity: tq + rq }]
          : [{ id: Number(vid), quantity: tq }, { id: Number(reward()?.id), quantity: rq }];
        try {
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const payload = { items };
          if (cart && typeof cart.getSectionsToRender === 'function') {
            payload.sections = cart.getSectionsToRender().map((s) => s.id);
            payload.sections_url = window.location.pathname;
          }
          const res = await fetch(`${base}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message);
          const code = deal.dataset.code;
          if (code) { await fetch(`${base}discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }); }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dabi-deals', productVariantId: String(vid), cartData: data });
          if (cart && typeof cart.renderContents === 'function' && data.sections) {
            cart.classList.remove('is-empty');
            // renderContents ilk ürünün key'ini bekler
            cart.renderContents({ ...data, id: data.items?.[0]?.variant_id, key: data.items?.[0]?.key });
          } else {
            document.getElementById('cart-icon-bubble')?.click();
          }
          say(code ? `${root.dataset.labelAdded} ${root.dataset.labelCode}` : root.dataset.labelAdded);
          btn.classList.add('is-done');
        } catch (e) {
          say(root.dataset.labelError, true);
        }
        btn.disabled = false;
      });
    });
  };

  const boot = () => document.querySelectorAll('[data-dabi-deals]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { const r = e.target.querySelector('[data-dabi-deals]'); if (r) { delete r.dataset.ready; init(r); } });
})();
